import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import legalService from '../../services/legal.service';
import type { LegalDocumentSummary } from '../../constants/legalDocuments';
import LegalConsentModal from './LegalConsentModal';
import {
  clearLegalConsentResumePath,
  getLegalConsentResumePath,
  setLegalConsentResumePath,
} from '../../utils/legalConsentFlow';
import { resolveDefaultRouteByRole } from '../../utils/workbenchView';
import { detectMobileOrMiniProgram } from '../../utils/supplierView';

/**
 * 登录后检查是否有待确认的法律文档（含协议升级场景）
 */
const LegalConsentGate: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, authInitialized, user, logout } = useAuthStore();
  const [pending, setPending] = useState<LegalDocumentSummary[]>([]);
  const [checked, setChecked] = useState(false);

  const onLegalDocumentPage = location.pathname.startsWith('/legal/');

  useEffect(() => {
    if (!authInitialized || !isAuthenticated || !user?.id) {
      setPending([]);
      setChecked(false);
      return;
    }
    let cancelled = false;
    void (async () => {
      try {
        const res = await legalService.getPendingDocuments();
        if (!cancelled) {
          setPending(res.documents || []);
          setChecked(true);
        }
      } catch {
        if (!cancelled) {
          setPending([]);
          setChecked(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authInitialized, isAuthenticated, user?.id]);

  useEffect(() => {
    if (pending.length > 0 && !onLegalDocumentPage) {
      setLegalConsentResumePath(`${location.pathname}${location.search}`);
    } else if (pending.length > 0 && onLegalDocumentPage && !getLegalConsentResumePath() && user?.role) {
      setLegalConsentResumePath(resolveDefaultRouteByRole(user.role, detectMobileOrMiniProgram()));
    }
  }, [pending.length, onLegalDocumentPage, location.pathname, location.search, user?.role]);

  if (!isAuthenticated || !checked || !pending.length || onLegalDocumentPage) {
    return null;
  }

  return (
    <LegalConsentModal
      open
      documents={pending}
      onAccepted={() => {
        clearLegalConsentResumePath();
        setPending([]);
      }}
      onCancel={() => logout()}
    />
  );
};

export default LegalConsentGate;
